// ============================================================================
// HELP SERVICE — the User Guide (setup/navigation design section 7)
// ============================================================================
// Pages are written in crs-doc/help and served by the API (today from a folder, later from a central
// help service). The web never knows where they live.

import { get } from '../client/axiosClient';
import { buildEndpoint, buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type { ApiResponse } from '../types/common.types';

export interface HelpPageInfo {
  id: string;
  title: string;
  /** Where it sits in the contents, e.g. "Setup › Restaurant". */
  section: string;
  order: number;
  /** Not yet reviewed: shows a Draft tag. */
  draft: boolean;
}

export interface HelpPage extends HelpPageInfo {
  markdown: string;
}

export interface HelpSearchHit extends HelpPageInfo {
  snippet: string;
}

export const helpService = {
  async getContents(): Promise<HelpPageInfo[]> {
    const res = await get<ApiResponse<HelpPageInfo[]>>(buildEndpoint('/help/contents'));
    return res.data.data ?? [];
  },

  /** Null when there is no page with that id yet. */
  async getPage(pageId: string): Promise<HelpPage | null> {
    try {
      const res = await get<ApiResponse<HelpPage>>(buildEndpoint(`/help/pages/${encodeURIComponent(pageId)}`));
      return res.data.data ?? null;
    } catch (err: any) {
      if (err?.response?.status === 404) return null;
      throw err;
    }
  },

  async search(q: string): Promise<HelpSearchHit[]> {
    const res = await get<ApiResponse<HelpSearchHit[]>>(buildEndpointWithQuery('/help/search', { q }));
    return res.data.data ?? [];
  },
};

export default helpService;
